export enum StatisticsKind {
  YIELD_APPLIED_DOSE = 'yieldAppliedDose',
  YIELD_STEM_NUMBER = 'yieldStemNumber',
  YIELD_ZONE_STRENGTH = 'yieldZoneStrength',
  YIELD_SOIL_PARAMETER = 'yieldSoilParameter',
  SOIL_TEMPERATURE = 'soilTemperature',
  DECISION_SUPPORT = 'decisionSupport'
}

export enum StatisticsSource {
  YIELD = 'yield',
  APPLIED_DOSE = 'appliedDose',
  STEM_NUMBER = 'stemNumber',
  ZONE_STRENGTH = 'zoneStrength',
  SOIL_SAMPLE = 'soilSample',
  SOIL_TEMPERATURE = 'soilTemperature'
}

export enum StatisticsStatus {
  ERROR = 'error',
  GENERATING = 'generating',
  GENERATED = 'generated'
}

export enum StatisticsView {
  PARCEL = 'parcel',
  ZONE = 'zone'
}

export enum StatisticsWizardParcelDataState {
  VALID = 'valid',
  INVALID_STATISTICS_KIND = 'invalidStatisticsKind',
  INVALID_INPUT = 'invalidInput'
}

export enum StatisticsWizardViewState {
  NORMAL = 'normal',
  LEFT_ONLY = 'leftOnly',
  RIGHT_ONLY = 'rightOnly'
}
